export default __webpack_public_path__ + "static/media/img1.658acb96.png";